import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, MembershipType, MessageType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { GenericTreeNode } from '../../generic-tree/generic-tree-node';
import { GenericTreeComponent } from '../../generic-tree/generic-tree.component';
import { LeftRightSelectionBoxComponent } from '../../left-right-selection-box/left-right-selection-box.component';
import { RestService } from '../../../services/rest/rest.service';
import { User } from '../../../models/user';
import { CellTemplateType, GenericColDef, GridContext } from '../../../models/grid-context';
import { Role } from '../../../models/role';
import { createOrgNameOrIdRoleHandles } from '../../../models/utils';

@Component({
    standalone: false,
    selector: 'res-membership-modal',
    templateUrl: './membership-modal.component.html',
    styleUrls: ['./membership-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MembershipModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(LeftRightSelectionBoxComponent, { static: true }) leftRightSelectionBoxComponent: LeftRightSelectionBoxComponent;
    itemsLeft = new Array<any>();
    itemsRight = new Array<any>();
    originalItemsRight = new Array<string>();
    modalTitle = 'Add / Remove Members';
    modalClass = 'membership-modal';
    modalAutomationId = 'add-remove-members-modal';
    modalHelpIndex = HelpIndex.myedisc_member_select_popup_dlg;
    isBusyLeft = false;
    isBusy = false;
    isSaveDisabled = false;
    isBusyMessage = 'Assigning Members ...';
    isBusyMessageLeft = 'Loading Available Members ...';
    hideOrgUserAndGroups: boolean;
    rightSelectAllChecked = false;
    leftSelectAllChecked = false;
    rightSelectAllDisabled = false;
    leftSelectAllDisabled = false;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService) {
        super(modalService, modalRef);

    }

    ngOnInit(): void {
        if (this.modalData.projectName) {
            this.modalTitle = `Add / Remove '${this.modalData.projectName}' Members`;
        } else if (this.modalData.organizationName) {
            this.modalTitle = `Add / Remove '${this.modalData.organizationName}' Members`;
        }
        this.hideOrgUserAndGroups = this.modalData.membershipType !== MembershipType.organization && !this.modalData.isSystemGroupsOrSystemOrgs;
        this.loadData();
    }

    isGroup(): boolean {
        if (this.modalData.membershipType === MembershipType.group) {
            return true;
        }
        return false;
    }
 
    loadData(): void {
        this.isBusyLeft = true;
        if (this.modalData?.membershipType !== MembershipType.project && this.modalData?.membershipType !== MembershipType.organization) {
            const endpoint = this.modalData.isSystemSettingsContext ? Endpoint.adminOrgManager_listUsersAndGroups : Endpoint.orgManager_listUsers;
            const request = this.modalData.isSystemSettingsContext ? {
                onlyGroups: false,
                onlyUsers: true,
                systemScope: true,
                organizationName: this.commonService.currentUser?.importedFromSystemUser || this.commonService.currentUser?.originalCustomerName === 'super_system_customer' ? 'super_system_customer' : this.commonService?.currentUser?.customerName
            }
                : {};
            this.restService.post(endpoint, request).then(response => {
                if (response && response.users) {
                    response.users.forEach(entity => {
                        const user = new User(entity);
                        this.modalData.leftList.push(user);
                    });
                    this.createNodes();
                }
            }, error => {
                this.isBusyLeft = false;
            });
        } else {
            this.createNodes();
        }

    }

    createNodes(): void {
        if (this.modalData && this.modalData.membershipType) {
            if (this.modalData.membershipType === MembershipType.group) {
                this.modalTitle = 'Add / Remove Members';
                if (!this.modalData.hideSystemUsers) {
                    this.itemsLeft.push(new GenericTreeNode({
                        name: 'System Users', automationId: this.modalAutomationId + '-system-users',
                        isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, childPadding: 7, hasCheckbox: true,
                        isCheckedOnSelect: true, checkboxBeforeExpander: true, isCheckboxDisabled: true, isHeaderSelectable: true
                    }));
                }
                if (!this.modalData.isSystemGroupsOrSystemOrgs) {
                    this.itemsLeft.push(new GenericTreeNode({
                        name: 'Users', automationId: this.modalAutomationId + '-users',
                        isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, childPadding: 7, hasCheckbox: true,
                        isCheckedOnSelect: true, checkboxBeforeExpander: true, isCheckboxDisabled: true, isHeaderSelectable: true
                    }));
                }
            } else {
                this.itemsLeft.push(new GenericTreeNode({
                    name: 'System Groups', automationId: this.modalAutomationId + '-system-groups',
                    isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, childPadding: 7, hasCheckbox: true,
                    isCheckedOnSelect: true, checkboxBeforeExpander: true, isCheckboxDisabled: true, isHeaderSelectable: true
                }));
                if (this.hideOrgUserAndGroups) {
                    this.itemsLeft.push(new GenericTreeNode({
                        name: 'Groups', automationId: this.modalAutomationId + '-groups',
                        isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, hasCheckbox: true,
                        isCheckedOnSelect: true, checkboxBeforeExpander: true, childPadding: 7, isCheckboxDisabled: true, isHeaderSelectable: true
                    }));
                }
                this.itemsLeft.push(new GenericTreeNode({
                    name: 'System Users', automationId: this.modalAutomationId + '-system-users',
                    isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, hasCheckbox: true,
                    isCheckedOnSelect: true, checkboxBeforeExpander: true, childPadding: 7, isCheckboxDisabled: true, isHeaderSelectable: true
                }));
                if (!this.modalData.isSystemGroupsOrSystemOrgs) {
                    this.itemsLeft.push(new GenericTreeNode({
                        name: 'Users', automationId: this.modalAutomationId + '-users',
                        isExpanded: true, isExpandedOnSelect: true, isSelectable: false, isExpandable: true, hasCheckbox: true,
                        isCheckedOnSelect: true, checkboxBeforeExpander: true, childPadding: 7, isCheckboxDisabled: true, isHeaderSelectable: true
                    }));
                }
            }
        }
        if (this.modalData && this.modalData.leftList) {
            this.modalData.leftList.forEach(member => {
                if (this.modalData.rightList && this.modalData.rightList.filter(m => m.handle === member.handle).length === 0) {
                    const isCurrentUser = member.userName === this.commonService?.currentUser?.userName;
                    const disableMember = isCurrentUser && !this.modalData.isSystemSettingsProjects;
                    if (this.modalData.membershipType === MembershipType.group) {
                        if (member.type === 'System User' && !this.modalData.hideSystemUsers) {
                            member.parentName = 'System Users';
                            this.itemsLeft[0].isCheckboxDisabled = false;
                            this.itemsLeft[0].children.push(new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                data: member, childPadding: 7, customColumn: member?.roles[0]?.name
                            }));
                        } else if (member.type === 'User' && !this.modalData.isSystemGroupsOrSystemOrgs) {
                            member.parentName = 'Users';
                            const itemsLeftObj = this.modalData.hideSystemUsers ? this.itemsLeft[0] : this.itemsLeft[1];
                            itemsLeftObj.isCheckboxDisabled = false;
                            itemsLeftObj.children.push(new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                data: member, childPadding: 7, customColumn: member?.roles[0]?.name
                            }));
                        }
                    } else {
                        if (member.type === 'System User') {
                            member.parentName = 'System Users';
                            const node = new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                isDisabled: disableMember,
                                data: member, childPadding: 7
                            })
                            if (this.modalData.membershipType === MembershipType.project) {
                                node.customColumn = member?.roles[0]?.name
                            } else {
                                node.customAllOptions = this.modalData.roleOptions;
                            }
                            this.itemsLeft[this.hideOrgUserAndGroups ? 2 : 1].isCheckboxDisabled = false;
                            this.itemsLeft[this.hideOrgUserAndGroups ? 2 : 1].children.push(node);
                        } else if (member.type === 'User' && !this.modalData.isSystemGroupsOrSystemOrgs) {
                            member.parentName = 'Users';
                            const node = new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                isDisabled: disableMember,
                                data: member, childPadding: 7
                            })
                            if (this.modalData.membershipType === MembershipType.project) {
                                node.customColumn = member?.roles[0]?.name
                            } else {
                                node.customAllOptions = this.modalData.roleOptions;
                            }
                            this.itemsLeft[3].isCheckboxDisabled = false;
                            this.itemsLeft[3].children.push(node);
                        } else if (member.type === 'System Group') {
                            member.parentName = 'System Groups';
                            const node = new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                data: member, childPadding: 7
                            })
                            if (this.modalData.membershipType === MembershipType.project) {
                                node.customColumn = member?.roles[0]?.name
                            } else {
                                node.customAllOptions = this.modalData.roleOptions;
                            }
                            this.itemsLeft[0].isCheckboxDisabled = false;
                            this.itemsLeft[0].children.push(node);
                        } else if (member.type === 'Group' && this.hideOrgUserAndGroups) {
                            member.parentName = 'Groups';
                            const node = new GenericTreeNode({
                                hasCheckbox: true, isCheckedOnSelect: true, name: member.name,
                                icon: member.iconClass, iconColor: member.iconColor, automationId: this.modalAutomationId + '-' + member.name,
                                data: member, childPadding: 7
                            })
                            if (this.modalData.membershipType === MembershipType.project) {
                                node.customColumn = member?.roles[0]?.name
                            } else {
                                node.customAllOptions = this.modalData.roleOptions;
                            }
                            this.itemsLeft[this.hideOrgUserAndGroups ? 1 : 0].isCheckboxDisabled = false;
                            this.itemsLeft[this.hideOrgUserAndGroups ? 1 : 0].children.push(node);
                        }
                    }
                }
            });

            if (this.itemsLeft[0]) {
                this.itemsLeft[0].children = this.itemsLeft[0].children?.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
            if (this.itemsLeft[1]) {
                this.itemsLeft[1].children = this.itemsLeft[1].children?.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
            if (this.itemsLeft[2]) {
                this.itemsLeft[2].children = this.itemsLeft[2].children?.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
            if (this.itemsLeft[3]) {
                this.itemsLeft[3].children = this.itemsLeft[3].children?.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
            
            if (this.modalData.membershipType === MembershipType.project && this.modalData.isSystemSettingsContext) {
                this.itemsLeft = this.itemsLeft?.filter(item => item?.name !== 'Groups' && item?.name !== 'Users');
            }

            if (this.modalData?.membershipType !== MembershipType.project) {
                setTimeout(() => {
                    this.leftRightSelectionBoxComponent?.setLeftItems(this.itemsLeft);
                });
            }
        }

        if (this.modalData && this.modalData.rightList) {
            this.itemsRight.push(new GenericTreeNode({
                name: '',
                isExpandable: true,
                isExpanded: true,
                isExpandedOnSelect: true,
                isSelectable: false,
                hideExpander: true,
                children: [],
                hideParent: true
            }));
            this.modalData.rightList.forEach(member => {
                if (member.type === 'System Group') {
                    member.parentName = 'System Groups';
                } else if (member.type === 'Group' && this.hideOrgUserAndGroups) {
                    member.parentName = 'Groups';
                } else if (member.type === 'System User') {
                    member.parentName = 'System Users';
                } else if (member.type === 'User' && !this.modalData.isSystemGroupsOrSystemOrgs) {
                    member.parentName = 'Users';
                }
                if (this.modalData.membershipType === 'group') {
                    this.itemsRight[0].children.push(new GenericTreeNode({
                        hasCheckbox: true, isCheckedOnSelect: true, automationId: this.modalAutomationId + '-' + member.name,
                        name: member.name ? member.name : member.userName ? member.userName : '', hideExpander: true, isExpandable: false,
                        icon: member.iconClass, iconColor: member.iconColor,
                        data: member, customColumn: member?.roles[0]?.name, childPadding: 7
                    }));
                    this.originalItemsRight.push(member.name ? member.name : member.userName ? member.userName : '');
                } else {
                    const isCurrentUser = member.userName === this.commonService.currentUser.userName;
                    const disableMember = isCurrentUser && !this.modalData.isSystemSettingsProjects;
                    const node = new GenericTreeNode({
                        hasCheckbox: true, isCheckedOnSelect: true, automationId: this.modalAutomationId + '-' + member.name,
                        name: member.name ? member.name : member.userName ? member.userName : '', hideExpander: true, isExpandable: false,
                        icon: member.iconClass, iconColor: member.iconColor,
                        isDisabled: disableMember,
                        data: member, childPadding: 7
                    })
                    if (this.modalData.membershipType === MembershipType.project) {
                        node.customColumn = member?.roles[0]?.name
                    } else {
                        node.customAllOptions = this.modalData.roleOptions;
                    }

                    const isAddingBlocked = this.hideOrgUserAndGroups && this.modalData?.isSystemSettingsContext === true && ['User', 'Group'].includes(member.type);

                    if (!isAddingBlocked) {
                        this.itemsRight[0].children.push(node);
                    }
                }
            });

            if (this.modalData?.membershipType !== MembershipType.project) {
                setTimeout(() => {
                    this.leftRightSelectionBoxComponent?.setRightItems(this.itemsRight);
                })
            }
        }
        this.isBusyLeft = false;
    }

    okEnabled(): boolean {
        if (this.modalData.membershipType === 'group') {
            return this.isGroupDirty();
        } else {
            return this.itemsRight && this.itemsRight[0]?.children?.length > 0;
        }
    }

    ok(): void {
        if (this.modalData?.isNewOrgCreation || this.modalData?.isNewProjectCreation || this.modalData?.isProjectMembers) {
            this.closeModal(true, this.itemsRight[0]?.children);
            return;
        }
        this.isBusy = this.isSaveDisabled = true;
        if (this.modalData?.membershipType === 'project') {
             if (this.itemsRight[0]?.children && this.itemsRight[0]?.children.length) {
                const permissionMap = { userRoleSetList: [], groupRoleSetList: [] };
                this.itemsRight[0]?.children.forEach(element => {
                    const item = { name: element.data.name, roleHandles: [element.data.roles[0]?.handle] };
                    if (element.data.type.includes('User')) {
                        permissionMap.userRoleSetList.push(item);
                    } else if (element.data.type.includes('Group')) {
                        permissionMap.groupRoleSetList.push(item);
                    }
                });

                if (permissionMap.userRoleSetList.length > 0 || permissionMap.groupRoleSetList.length > 0) {
                    this.restService.post(Endpoint.permissionManager_setPermission, {
                        permissionMap: permissionMap,
                        objectHandle: this.modalData?.project.handle,
                        systemScope: true
                    }).then((response) => {
                        this.isBusy = this.isSaveDisabled = false;
                        this.commonService.sendMessage(MessageType.project);
                        this.closeModal(true, this.itemsRight[0]?.children);
                    }).catch(error => {
                        this.isBusy = this.isSaveDisabled = false;
                        this.closeModal(true, []);
                    });
                }
            }
        } else if (this.modalData?.membershipType === 'organization') {
            if (this.itemsRight[0]?.children && this.itemsRight[0]?.children.length) {
                const permissionMap = { userRoleSetList: [], groupRoleSetList: [] };
                const userNames = [], userRoles = [], groupNames = [], groupRoles = [];
                this.itemsRight[0]?.children.forEach((member) => {
                    const item = { name: member.data.name, roleHandles: [member.data?.selectedRole?.handle] };
                    if (member.data?.type?.includes('User')) {
                        if (member?.data?.type === 'System User') {
                            userNames.push(member.data?.name);
                            userRoles.push(member.data?.selectedRole?.handle)
                        }
                        permissionMap.userRoleSetList.push(item);
                    } else {
                        if (member?.data?.type === 'System Group') {
                            groupNames.push(member?.data?.name);
                             groupRoles.push(member?.data?.selectedRole?.handle)
                        }
                        permissionMap.groupRoleSetList.push(item);
                    }
                })

                if (userRoles.length > 0 || groupRoles.length > 0 || permissionMap.userRoleSetList.length > 0 || permissionMap.groupRoleSetList.length > 0) {
                    const userNameRoles = createOrgNameOrIdRoleHandles(userNames, userRoles);
                    const groupNameRoles = createOrgNameOrIdRoleHandles(groupNames, groupRoles);
                    this.restService.post(Endpoint.adminOrgManager_setSystemMemberToOrg, {
                        userNameHandles: userNameRoles,
                        groupNameHandles: groupNameRoles,
                        permissionMap: permissionMap,
                        organizationName: this.modalData.organizationName,
                        systemScope: true
                    }).then((result) => {
                        this.isBusy = this.isSaveDisabled = false;
                        this.closeModal(true, this.itemsRight[0]?.children);
                    }).catch(error => {
                        this.isBusy = this.isSaveDisabled = false;
                        this.closeModal(true, []);
                    });
                }
            }
        } else {
            const userHandles = [];
            this.itemsRight[0]?.children.forEach(element => {
                userHandles.push(element.data.name);
            });
            this.restService.post(Endpoint.groupManager_setUsers, {
                groupHandle: this.modalData?.selectedGroup?.handle,
                userHandles: userHandles,
                systemScope: this.modalData.isSystemSettingsContext
            }).then((result) => {
                this.isBusy = this.isSaveDisabled = false;
                this.closeModal(true, this.itemsRight[0]?.children);
            }).catch(error => {
                this.isBusy = this.isSaveDisabled = false;
                this.closeModal(true, []);
            });
        }
    }

    customMoveItems($event) {    
        this.deselectItems($event?.mode === 'add' ? this.itemsRight[0].children : this.itemsLeft);
        $event?.items.forEach(item => {
            let sourceArray = $event?.mode === 'add' ? this.itemsLeft : this.itemsRight[0].children;
            let targetArray = $event?.mode === 'add' ? this.itemsRight[0].children : this.itemsLeft;
            if (item && !item.isHeaderSelectable) {
                if (item?.data?.parentName) {
                    const sourceParent = sourceArray.filter(n => n.name === item.data.parentName)[0] as GenericTreeNode;
                    if (sourceParent) {
                        sourceArray = sourceParent.children;
                    }
                    const targetParent = targetArray.filter(n => n.name === item.data.parentName)[0] as GenericTreeNode;
                    if (targetParent) {
                        targetArray = targetParent.children;
                        targetParent.isCheckboxDisabled = false;
                    }
                }
                sourceArray.splice(sourceArray.indexOf(item), 1);
                const newTreeItem: GenericTreeNode = new GenericTreeNode(item);
                targetArray.push(newTreeItem);
            } else {
                if (item) {
                    item.isCheckboxDisabled = true;
                }
            }
            this.leftRightSelectionBoxComponent.sortList(targetArray);
        });
        this.deselectItems($event?.mode === 'add' ? this.itemsLeft : this.itemsRight[0].children);
        this.leftRightSelectionBoxComponent.setLeftItems(this.itemsLeft);
        this.leftRightSelectionBoxComponent.setRightItems(this.itemsRight);
    }

    deselectItems(items) {
        items.forEach(el => {
            el.isChecked = false;
            el.children?.forEach(item => {
                item.isChecked = false;
            })
        });
    }

    isLeftListPartiallySelected() {
        if (this.leftRightSelectionBoxComponent?.checkAllSelected(true) && !this.leftSelectAllChecked) {
            setTimeout(() => {
                this.leftSelectAllChecked = true;
            });
        }
        if (this.leftRightSelectionBoxComponent?.genericTrees?.first.selectedNodes.length === 0 && this.leftSelectAllChecked) {
            setTimeout(() => {
                this.leftSelectAllChecked = false;
            });
        }
        this.leftSelectAllDisabled = !this.leftRightSelectionBoxComponent?.genericTrees?.first.childrenCanBeSelected(null);
        return this.leftRightSelectionBoxComponent.checkPartiallySelected(true);
    }

    isRightListPartiallySelected() {
        if (this.leftRightSelectionBoxComponent?.checkAllSelected(false) && !this.rightSelectAllChecked) {
            setTimeout(() => {
                this.rightSelectAllChecked = true;
            });
        }
        if (this.leftRightSelectionBoxComponent?.genericTrees?.last.selectedNodes.length === 0 && this.rightSelectAllChecked) {
            setTimeout(() => {
                this.rightSelectAllChecked = false;
            });
        }
        this.rightSelectAllDisabled = !this.leftRightSelectionBoxComponent?.genericTrees?.last.childrenCanBeSelected(null);
        return this.leftRightSelectionBoxComponent.checkPartiallySelected(false);
    }

    leftSelectionChanged(event) {
        const treeComponent = this.leftRightSelectionBoxComponent?.genericTrees?.first;
        const selected = !treeComponent.childrenAllSelected(null, true);
        treeComponent.treeControl.dataNodes.forEach(n => {
            if (!n.isCheckboxDisabled && !n.isDisabled) {
                n.isChecked = selected;
            }
        });
        treeComponent.treeDataUpdated();
        this.leftRightSelectionBoxComponent?.genericTrees?.last.deselectAllNodes();
    }


    rightSelectionChanged(event) {
        const treeComponent = this.leftRightSelectionBoxComponent?.genericTrees?.last;
        const selected = !treeComponent.childrenAllSelected(null, true);
        treeComponent.treeControl.dataNodes.forEach(n => {
            if (n.children?.length > 0) {
                n.children.forEach(item => {
                    if (!item.isCheckboxDisabled && !item.isDisabled) {
                        item.isChecked = selected;
                    }
                })
            }
        });
        treeComponent.treeDataUpdated();
        this.leftRightSelectionBoxComponent?.genericTrees?.first.deselectAllNodes();
    }

    isGroupDirty(): boolean {
        if (this.itemsRight && this.itemsRight[0]) {
            if (this.itemsRight[0].children.length !== this.originalItemsRight.length) {
                return true;
            } else {
                for (const node of this.itemsRight[0].children) {
                    const itemIndex = this.originalItemsRight.findIndex(originalItem => originalItem === node.name);
                    if (itemIndex === -1) {
                        return true;
                    }
                }
            }
            return false;
        }
        return false;
    }


    filterDataRight(value: string): void {
        const treeComponent = this.leftRightSelectionBoxComponent?.genericTrees?.last;
        this.applyFilterToTree(value, treeComponent);
    }

    filterDataLeft(value: string): void {
        const treeComponent = this.leftRightSelectionBoxComponent?.genericTrees?.first;
        this.applyFilterToTree(value, treeComponent);
    }

    applyFilterToTree(value: string, treeComponent: GenericTreeComponent): void {
        if (treeComponent) {
            const filterBy = (node: GenericTreeNode) => node.name.toLowerCase().includes(value);
            treeComponent.treeControl.dataNodes.forEach(n => {
                if (n.children?.length > 0) {
                    for (let i = 0; i < n.children.length; i++) { 
                        n.filterBy = filterBy;
                    }    
                    const visibleChildrenCount = n.children.filter(child => filterBy(child)).length;
                    if(visibleChildrenCount === 0) {
                        n.isCheckboxDisabled = true;
                        n.isChecked = false;
                    } else {
                        n.isCheckboxDisabled = false;
                    }               
                }                
            });    
            treeComponent.updateSelectionAfterFilter(value);       
            treeComponent.treeDataUpdated();          
        }
    }
}
